import styled from "styled-components";

export const Container = styled.div``;

export const Title = styled.div<{ selected?: boolean }>`
  font-family: "Cabin", sans-serif;
  font-size: 14px;
  color: ${({ selected }) => (selected ? "#988038" : "#fff")};
`;
